export default [{
    path: 'operation-person-list-report',
    component: () => import('@/views/organization/report/operation-person-list-report'),
}]